import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class Comments {
    list(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.comments}?${params}`)
    }

    remove(id) {
        return BaseService.post(
            `${APIPath.removeComments}?id=${id}`,
        )
    }

    addUpdate(data) {
        return BaseService.post(`${APIPath.comments}`, data)
    }
}

const CommentsService = new Comments()
Object.freeze(CommentsService)
export { CommentsService }
